<template>
  <main>
    <h2 class="ttl">{{$t('withdrawConfirm')}}</h2>
    <p class="center">{{$t('withdrawAccess')}}</p>
    <div class="account-box">
      <p class="txt-pw">
        <span v-if="!$v.password.required">{{$t(this.getMessage($v.password , {"name" : "パスワード"}))}}</span>
        <input type="password" id="pw" name="pw" placeholder="Password" v-model.trim="$v.password.$model">
      </p>
    </div>
    <p class="txt-error center mb40">
      <validationError :error="(this.$v.$invalid && this.vaError)"/>
      <firebaseError :error="this.fbError" :errorCode="errorCode"/>
    </p>
    <p class="btn-normal-2 mb30">
      <router-link to="" @click.native="withdraw">{{$t('withdraw')}}</router-link>
    </p>
    <p class="btn-normal mb30">
      <router-link :to="{ name: 'Home' }">{{$t('returnTop')}}</router-link>
    </p>
  </main>
</template>

<script>
import firebase from 'firebase'
import firebaseError from "@/error/FirebaseError"
import validationError from "@/error/ValidationError"
import { required } from "vuelidate/lib/validators"

export default {
  name: 'WithdrawConfirm',
  data () {
    return {
      password: '',
      vaError : false, //バリデーションエラー
      fbError : false, //firebaseエラー
      errorCode: "",
      db: firebase.firestore(),
    }
  },
  validations: {
    password: {
      required,
    },
  },
  components: {
    firebaseError,
    validationError,
  },
  methods: {
    async withdraw () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.vaError = true
        return
      }
      var user = firebase.auth().currentUser
      try {
        const credential = firebase.auth.EmailAuthProvider.credential(user.email, this.password)
        await user.reauthenticateWithCredential(credential)
        await this.db.collection("users").doc(user.uid).update({status:"0",updated_at:firebase.firestore.FieldValue.serverTimestamp()});
        await user.delete()
        this.$router.push({ name: 'WithdrawCompleted' })
      } catch(error) {
          this.errorCode = error.code
          this.fbError = true
          return
      }
    }
  }
}
</script>
